module.exports = __webpack_public_path__ + "img/marca.7c6ec714.png";